import useIsScreenSize from 'js/hooks/use-is-screen-size';

import Heading from 'components/heading/Heading';
import AutoGrid from 'components/auto-grid/AutoGrid';
import LinkWrapper from 'components/link-wrapper/LinkWrapper';
import PortfolioTile from './PortfolioTile';

import { IPortfolioTiles } from 'source/NFR.types';

const PortfolioTiles: React.FC<IPortfolioTiles> = ({ tiles }) => {
  const isTabletOrDesktop = useIsScreenSize('md');
  const minimumTileSize = isTabletOrDesktop ? 241 : 155;

  return (
    <div className="portfolio-tiles">
      <AutoGrid minWidth={minimumTileSize} flexibleGutter>
        {AutoGridItem =>
          tiles?.map(({ theme, link }) => {
            const { OuterLink, InnerLink } = LinkWrapper(true, link.url);
            return (
              <AutoGridItem key={link.text}>
                <OuterLink className="portfolio-tiles--link">
                  <div className="portfolio-tiles--tile-square">
                    <PortfolioTile className="portfolio-tiles--tile" theme={theme}>
                      <InnerLink className="portfolio-tiles--title">
                        <Heading>{link.text}</Heading>
                      </InnerLink>
                    </PortfolioTile>
                  </div>
                </OuterLink>
              </AutoGridItem>
            );
          })
        }
      </AutoGrid>
    </div>
  );
};

PortfolioTiles.displayName = 'PortfolioTiles';

export default PortfolioTiles;
